import { CSSProperties } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import cn from 'classnames'
import styles from './Loader.module.scss'
import { PropsFromRedux } from './index'

export interface IProps extends PropsFromRedux {
  top?: number
  isClientPortal?: boolean
}

const Loader = ({ top = null, isSidebarOpen, isClientPortal }: IProps) => {
  return (
    <div className={styles.loaderWrapper} data-cy="loader">
      <LinearProgress
        style={{ '--loader-top': top === null ? undefined : `${top}px` } as CSSProperties}
        className={cn(styles.loader, {
          [styles.reduced]: isSidebarOpen,
          [styles.clientBar]: isClientPortal,
        })}
      />
    </div>
  )
}

export default Loader
